import { getBalance } from './getBalance.js';
import { getTransactionFee } from './getTransactionFee.js';
import { getUTXOs } from './getUTXOs.js';
export const blockcypherMethods = {
    getBalance,
    getUTXOs,
    getTransactionFee,
};
//# sourceMappingURL=methods.js.map